import Immutable from 'immutable';
import {
  FLAG_GETTING_COMPANIES,
  GET_COMPANIES,
  CLEAR_COMPANIES,
  FLAG_COMPANY_ACTIVITY,
  GET_COMPANY,
  CLEAR_COMPANY,
  GET_COMPANY_CUSTOMERS,
  GET_COMPANY_BUSINESSES,
  CLEAR_COMPANY_BUSINESSES,
  CLEAR_COMPANY_CUSTOMERS,
  FLAG_GETTING_COMPANY_CUSTOMERS,
  FLAG_GETTING_COMPANY_BUSINESSES,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    customers: Immutable.List(),
    activityCustomers: Immutable.List(),
    businesses: Immutable.List(),
    activityBusinesses: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_COMPANIES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_COMPANIES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_COMPANIES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_COMPANY_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_COMPANY:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_COMPANY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_GETTING_COMPANY_CUSTOMERS:
      if (action.payload) {
        return state.setIn(
          ['current', 'activityCustomers'],
          state.getIn(['current', 'activityCustomers']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activityCustomers'],
        state.getIn(['current', 'activityCustomers']).pop(),
      );
    case GET_COMPANY_CUSTOMERS:
      return state.setIn(
        ['current', 'customers'],
        Immutable.List(action.payload),
      );
    case CLEAR_COMPANY_CUSTOMERS:
      return state.setIn(
        ['current', 'customers'],
        INITIAL_STATE.getIn(['current', 'customers']),
      );
    case FLAG_GETTING_COMPANY_BUSINESSES:
      if (action.payload) {
        return state.setIn(
          ['current', 'activityBusinesses'],
          state.getIn(['current', 'activityBusinesses']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activityBusinesses'],
        state.getIn(['current', 'activityBusinesses']).pop(),
      );
    case GET_COMPANY_BUSINESSES:
      return state.setIn(
        ['current', 'businesses'],
        Immutable.List(action.payload),
      );
    case CLEAR_COMPANY_BUSINESSES:
      return state.setIn(
        ['current', 'businesses'],
        INITIAL_STATE.getIn(['current', 'businesses']),
      );
    default:
      return state;
  }
};
